module.exports = __webpack_public_path__ + "static/media/AB_B6_2.09d1cc86.jpg";